import { render } from "./adminPerfiles-Component.vue?vue&type=template&id=64f1d25c&scoped=true"
import script from "./adminPerfiles-Component.vue?vue&type=script&lang=js"
export * from "./adminPerfiles-Component.vue?vue&type=script&lang=js"

import "./adminPerfiles-Component.vue?vue&type=style&index=0&id=64f1d25c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64f1d25c"]])

export default __exports__